import { useDispatch } from 'react-redux';
import { useEffect } from 'react';

import { addHours } from 'date-fns';

import { useAppSelector } from '../../shared/store';
import { loadMainPopupNotice, removeNoticePopup } from '../slice';
import { selectActiveMainPopupNotices } from '../main.selector';
import { storeMainNotice } from '../service/main-notice.storage.service';

export default function useMainNoticePopup() {
  const { hasSession } = useAppSelector(({ auth }) => auth);
  const popupNotices = useAppSelector(selectActiveMainPopupNotices);

  const dispatch = useDispatch();

  useEffect(() => {
    if (!hasSession) {
      return;
    }
    dispatch(loadMainPopupNotice());
  }, [dispatch, hasSession]);

  const removePopup = (targetId: number) => (noShowHours: number) => {
    if (noShowHours > 0) {
      const noShowDate = addHours(Date.now(), noShowHours);
      storeMainNotice({ id: targetId, noShowTime: noShowDate.getTime() });
    }

    dispatch(removeNoticePopup(targetId));
  };

  return { popupNotices, removePopup };
}
